














import { Component, Vue } from "vue-property-decorator";
import HomeSearch from "../components/HomeSearch.vue";
import RealDescription from "../components/RealDescription.vue";
import Articles from "../components/Articles.vue";
import UserQuotes from "../components/UserQuotes.vue";
import BrowseBrands from "../components/BrowseBrands.vue";
import CompanyVision from "../components/CompanyVision.vue";
import DownloadReal from "../components/DownloadReal.vue";
import HomeCards from "../components/HomeCards.vue";
import Footer from "../components/Footer.vue";

@Component({
  components: {
    HomeSearch,
    RealDescription,
    Articles,
    BrowseBrands,
    UserQuotes,
    DownloadReal,
    Footer,
    HomeCards,
  },
})
export default class Home extends Vue {
  get companies() {
    return this.$store.getters.companies;
  }
  mounted() {
    this.$store.commit("setSearch", "");
    this.$store.commit("setFilteredCompanies", this.companies);
  }
}
